import React from "react";
import { Field } from "redux-form";

const normalize = value => (value ? `${value}-01` : "");
const format = value => (value ? value.slice(0, -3) : "");

export default function MonthYearField(props) {
  const { ...rest } = props;

  return <Field type="month" normalize={normalize} format={format} {...rest} />;
}



// WEBPACK FOOTER //
// ./app/modules/shared/components/Forms/MonthYearField/MonthYearField.jsx